import { em } from 'polished'
import styled, { css } from 'styled-components'

import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import YouTubePlayer from 'components/YouTubePlayer'

const h500Mixin = css`
  height: ${p => p.theme.blocks.heightBlock500};
`

export const StyledSectionWrapper = styled(SectionWrapper)`
  position: relative;

  ${p => p.theme.mq.upMd} {
    height: ${em(516)};
  }
`

export const StyledYouTubePlayer = styled(YouTubePlayer)`
  height: ${p => (p.content ? 'inherit' : '62.5vw')};
`

export const StyledYouTubePlayerMd = styled(YouTubePlayer)`
  height: ${p => (p.content ? 'inherit' : '62.5vw')};

  ${p => p.theme.mq.upMd} {
    height: 100%;
    position: absolute;
  }
`

export const StyledIcon = styled(Icon)`
  ${({ id }) =>
    id === 'tedx' &&
    `
    width: ${em(117)};
    height: ${em(36)};
  `}
`

export const MobileWrapper = styled.div`
  ${p =>
    !p.innerText &&
    css`
      padding: 0 ${p => p.theme.indents.baseIndentXs};
    `};
  ${p => (p.innerText ? h500Mixin : 'height: auto')};
`
